import { Metric } from '../types';
import Icon from '../../../components/AppIcon';

interface MetricsShowcaseProps {
  metrics: Metric[];
  industryName: string;
}

const MetricsShowcase = ({ metrics, industryName }: MetricsShowcaseProps) => {
  return (
    <section className="py-16 bg-gradient-to-br from-primary/5 to-secondary/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Measurable Impact in {industryName}
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Real results from organizations leveraging our analytics platform
          </p>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {metrics.map((metric, index) => (
            <div
              key={index}
              className="bg-background rounded-xl p-6 border border-border shadow-brand hover:shadow-brand-lg transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name={metric.icon} size={20} className="text-primary" />
                </div>
                <div className={`flex items-center space-x-1 text-sm font-semibold ${
                  metric.trend === 'up' ? 'text-success' : 'text-error'
                }`}>
                  <Icon 
                    name={metric.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                    size={16} 
                  />
                  <span>{metric.change}</span>
                </div>
              </div>
              
              <div className="text-3xl font-bold text-foreground mb-2">
                {metric.value}
              </div>
              
              <div className="text-sm text-text-secondary">
                {metric.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MetricsShowcase;